import Vue from 'vue';
import update from './modules/update';

let mixins = [update];

for (let mixin of mixins) Vue.mixin(mixin);
